module.exports = __webpack_public_path__ + "img/img013.e33bea29.png";